import consumer from "./consumer"

// Função para obter o ID do payload (ajuste a forma como você obtém este ID)
const getPayloadId = () => {
  // Exemplo: buscando o ID de um data attribute no body ou em um elemento específico
  const element = document.querySelector('[data-payload-id]'); 
  return element ? element.dataset.payloadId : null;
};

const payloadId = getPayloadId();

if (payloadId) {
  consumer.subscriptions.create(
    // 1. O nome do Channel e os parâmetros necessários
    { channel: "PayloadChannel", id: payloadId }, 
    {
      connected() {
      // Called when the subscription is ready for use on the server
      console.log("Connected to PayloadChannel with ID:", payloadId);
      },
    
      disconnected() {
      // Called when the subscription has been terminated by the server
      console.log("Disconnected from PayloadChannel");
      },
    
      received(data) {
      // Called when there's incoming data on the websocket for this channel
      console.log("Received data:", data);
      // Lógica para processar os dados recebidos (ex: atualizar o DOM)
      }
    }
  );
} else {
    // Para depuração, caso não encontre o ID
    console.error("Payload ID not found. Subscription to PayloadChannel skipped."); 
}